var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('Hero'),_c('Service'),_c('Portfoilo'),_c('About'),_c('Team'),_c('Clients'),_c('Contact'),_c('Footer'),_c('Modals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }